import styled from 'styled-components';
import { Card } from 'react-bootstrap';

const CardHeader = styled(Card.Header)`
  margin-bottom: 0 !important;
`;

export { CardHeader };
